module.exports = __webpack_public_path__ + "static/cardbg02-0d1b460eecf238e47da4e06ed125dd49.png";